<template>
    <div>
        <div class="custom-font-semi-bold custom-text text-grey">
            <slot></slot>
        </div>
        <v-data-table :items="initialFiles" hide-actions hide-headers
                    no-data-text="No hay archivos disponibles">
        <template slot="items" slot-scope="props">
            <tr class="row-element" :key="props.item.id">
            <td>
              <a :href="props.item.url" target="_blank">{{ props.item.name }}</a>
              <span v-if="props.item.description" class="text-xs-left">: {{ props.item.description }}</span>
            </td>
            <td>
              <span class="upload-date">{{ props.item.createdAt }}</span>
            </td>
            <td class="text-xs-right" v-if="canEdit">
                <v-btn icon @click="remove(props.item)">
                <v-icon>delete</v-icon>
                </v-btn>
            </td>
            </tr>
        </template>
        </v-data-table>
    </div>
</template>

<script>

export default {
  props: {
    adjuntos: [Array, Object],
    canEdit: Boolean
  },

  data () {
    return {
      initialFiles: [],
      loading: false
    }
  },
  methods: {
    remove (item) {
      const index = this.initialFiles.indexOf(item)
      this.$emit('removedFile', this.initialFiles[index].id)
      this.initialFiles.splice(index, 1)
      this.initialFiles = [...this.initialFiles]
    },
    resetComponents () {
      Object.assign(this.$data, this.$options.data.call(this))
    },
    getAddedComprobante () {
      return this.comprobante
    },
    getAddedDeclaracion () {
      return this.declaracionJurada
    },
    assignInitialFiles () {
      this.initialFiles = this.adjuntos
    }
  },
  created () {
    this.assignInitialFiles()
  }
}
</script>
<style scoped>
  .upload-date {
    display: flex;
    align-items: flex-end;
    flex-direction: column;
  }
</style>
